// src/components/reports/SupervisorReport/SupervisorTable.tsx
import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography
} from '@mui/material';
import { SupervisorReportItem, formatCurrency, formatProfitRate } from '../../../../types/sales';

interface SupervisorTableProps {
  data: SupervisorReportItem[];
}

const SupervisorTable: React.FC<SupervisorTableProps> = ({ data }) => {
  // Get detail data (excluding total row)
  const getDetailData = (): SupervisorReportItem[] => {
    if (!data || data.length <= 1) return [];
    return data.slice(0, data.length - 1);
  };

  const detailData = getDetailData();
  if (detailData.length === 0) return null;

  return (
    <Box sx={{ mt: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
      <Typography variant="body2" color="textSecondary" gutterBottom>
        ※参考情報：表形式詳細
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>担当者名</TableCell>
              <TableCell align="right">工事件数</TableCell>
              <TableCell align="right">売上合計</TableCell>
              <TableCell align="right">粗利益</TableCell>
              <TableCell align="right">粗利益率</TableCell>
              <TableCell align="right">職長手当</TableCell>
              <TableCell align="right">最終利益</TableCell>
              <TableCell align="right">最終利益率</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {detailData.map((item) => (
              <TableRow key={item.supervisor_name}>
                <TableCell>{item.supervisor_name}</TableCell>
                <TableCell align="right">{item.project_count}</TableCell>
                <TableCell align="right">{formatCurrency(item.total_sales)}</TableCell>
                <TableCell
                  align="right"
                  sx={{ color: Number(item.final_profit) < 0 ? 'error.main' : 'success.main' }}
                >
                  {formatCurrency(item.final_profit)}
                </TableCell>
                <TableCell align="right">{formatProfitRate(item.final_profit)}</TableCell>
                <TableCell align="right">{formatCurrency(item.supervisor_allowance)}</TableCell>
                <TableCell
                  align="right"
                  sx={{ color: Number(item.final_profit) < 0 ? 'error.main' : 'success.main' }}
                >
                  {formatCurrency(item.final_profit)}
                </TableCell>
                <TableCell align="right">{formatProfitRate(item.final_profit_rate)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default SupervisorTable;